import React from 'react';
import { Button } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { Modal } from '@mui/material';
import useTranslation from 'Hooks/useTranslation';
import { colors } from 'Constants/Colors';

interface Props {
  open: boolean;
  closeModal: () => void;
  handleSubmit: () => void;
}

const QuestionnaireConfirmationModal = ({ open, closeModal, handleSubmit }: Props) => {
  const { t2 } = useTranslation('course_test');

  const onConfirmClick = () => {
    handleSubmit();
    closeModal();
  };

  return (
    <Modal open={open} onClose={closeModal}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          {t2('sure_end_evaluation')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t2('once_sent')}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
          <Button
            onClick={closeModal}
            variant="outlined"
            sx={{
              color: colors.GREEN,
              borderColor: colors.GREEN,
              '&:hover': {
                borderColor: colors.GREEN,
              },
            }}
          >
            {t2('cancel')}
          </Button>
          <Button
            onClick={onConfirmClick}
            variant="contained"
            sx={{
              bgcolor: colors.GREEN,
              '&:hover': {
                bgcolor: colors.GREEN_SHINING,
              },
            }}
          >
            {t2('send_answers')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuestionnaireConfirmationModal;
